<template>
    <v-container>
        <h2>Test Map</h2>
        <v-row>
            <google-map ref="map" style="width: 100%; height: 600px;" :center="{ lat: 0, lng: 0}" :zoom="1"></google-map>
        </v-row>
    </v-container>
</template>

<script>
import GmapMap from 'vue2-google-maps/src/components/map.vue'

export default {
    components:{
        "google-map": GmapMap
    },
    data: () => ({
        attempts: 0,
        emailVerification: null,
        password: null,
    }),
    methods: {
        verifyEmail() {},
    },
}
</script>
